import React, { useCallback, useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import Tooltip from '@mui/material/Tooltip';
import { apiUrl } from '../../apiBase';

export default function TemplatesStatus() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [data, setData] = useState(null);
  

  const load = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const res = await fetch(apiUrl('/admin/messages/status'), { credentials: 'include' });
      if (!res.ok) throw new Error('failed');
      const j = await res.json();
      setData(j);
    } catch (e) {
      setError('Mesaj şablon durumu alınamadı');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const ok = !!data && data.loaded && (data.missing_count === 0);

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>WhatsApp Mesaj Şablonları</Typography>
        {loading && <CircularProgress size={16} />}
        <Box sx={{ flex: 1 }} />
        <Button size="small" variant="outlined" onClick={load} disabled={loading}>Yenile</Button>
      </Box>
      {error && (
        <Typography color="error" variant="body2" sx={{ mb: 1 }}>{error}</Typography>
      )}
      {!data ? (
        <Box sx={{ py: 2, display: 'flex', justifyContent: 'center' }}>
          <CircularProgress size={22} />
        </Box>
      ) : (
        <Paper variant="outlined" sx={{ p: 2, borderRadius: 1.5 }}>
          <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap', rowGap: 1 }}>
            <Chip color={ok ? 'success' : 'warning'} label={ok ? 'Yüklendi' : 'Eksik Anahtarlar Var'} size="small" />
            <Chip label={`Sürüm: ${data.version || 'bilinmiyor'}`} size="small" />
            <Tooltip title={data.source || ''}>
              <Chip label={`Kaynak: ${(() => { try { return (data.source || '').split('\\').pop().split('/').pop() || '—'; } catch { return '—'; } })()}`} size="small" />
            </Tooltip>
            <Chip label={`Toplam Anahtar: ${data.total_keys ?? 0}`} size="small" />
            <Chip label={`Zorunlu: ${data.required_keys_count ?? 0}`} size="small" />
            <Chip color={data.missing_count > 0 ? 'warning' : 'default'} label={`Eksik: ${data.missing_count ?? 0}`} size="small" />
          </Stack>
          <Divider sx={{ my: 1.5 }} />
          {data.missing_count > 0 ? (
            <Box>
              <Typography variant="body2" sx={{ mb: 1 }}>Eksik anahtarlar:</Typography>
              <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                {(data.missing_keys || []).map((k) => (
                  <Chip key={k} label={k} size="small" variant="outlined" />
                ))}
              </Box>
            </Box>
          ) : (
            <Typography variant="body2" color="success.main">Tüm zorunlu mesaj şablonları mevcut.</Typography>
          )}
        </Paper>
      )}
    </Box>
  );
}
